export const LANGUAGE_STORAGE_KEY = 'i18nextLng'
export const LANGUAGE_INACTIVITY_TIMEOUT_MS = 2 * 60 * 1000

export const LANGUAGE_OPTIONS = [
  {
    code: 'en',
    englishLabel: 'English',
    nativeLabel: 'English',
  },
  {
    code: 'ar',
    englishLabel: 'Arabic',
    nativeLabel: 'العربية',
  },
  {
    code: 'ur',
    englishLabel: 'Urdu',
    nativeLabel: 'اردو',
  },
] as const

export type SupportedLanguage = typeof LANGUAGE_OPTIONS[number]['code']

function findLanguageOption(language: string | null) {
  return LANGUAGE_OPTIONS.find((option) => option.code === language) ?? null
}

export function isSupportedLanguage(language: string | null): language is SupportedLanguage {
  return findLanguageOption(language) !== null
}

export function getStoredLanguage(): SupportedLanguage | null {
  if (typeof window === 'undefined') return null

  const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
  return isSupportedLanguage(storedLanguage) ? storedLanguage : null
}

export function persistLanguage(language: SupportedLanguage) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
}

export function clearStoredLanguage() {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(LANGUAGE_STORAGE_KEY)
}
